/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ClusterPollingProgressBarModuleModule
 * @preferred
 */

import { NgModule } from '@angular/core';
import { VIPModule } from '@vmw/ngx-vip';
import { ClrProgressBarModule } from '@clr/angular';

import { ClusterPollingProgressBarComponent } from './components';

const clusterPollingProgressBarComponents = [
    ClusterPollingProgressBarComponent,
];

@NgModule({
    declarations: [
        ...clusterPollingProgressBarComponents,
    ],
    imports: [
        ClrProgressBarModule,
        VIPModule,
    ],
    exports: [
        ClusterPollingProgressBarComponent,
    ],
})
export class ClusterPollingProgressBarModule {}
